<template>
  <apexchart
    ref="chart"
    type="radialBar"
    :options="options"
    :series="chartSeries"
  ></apexchart>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
const props = defineProps({
  modelValue: {
    type: Number,
    default: null
  },
  fillBreakpoints: {
    type: Array,
    default: () => [
      { percentage: 50, color: 'error' },
      { percentage: 80, color: 'warning' },
      { percentage: 100, color: 'success' }
    ]
  }
})

const chart = ref(null)
const chartSeries = computed(() => {
  if (isNaN(props.modelValue) || props.modelValue == null) {
    return ['-']
  } else {
    return [props.modelValue.toFixed(0)]
  }
})

const options = ref({
  chart: {
    type: 'radialBar',
    sparkline: {
      enabled: true
    }
  },
  plotOptions: {
    radialBar: {
      hollow: {
        margin: 0,
        size: '65%'
      },
      track: {
        strokeWidth: '100%',
        background: '#e7e7e7',
        margin: 0
      },
      dataLabels: {
        name: {
          show: false
        },
        value: {
          offsetY: 5,
          fontSize: '14px'
        }
      }
    }
  },
  fill: {
    colors: ['var(--bg-brand)']
  },
  stroke: {
    lineCap: 'round'
  }
})

function setFillColor() {
  let color = 'var(--bg-brand-solid)'
  // Set color based on breakpoints
  for (const breakpoint of props.fillBreakpoints) {
    const currentPercentage = props.modelValue

    if (currentPercentage <= breakpoint.percentage) {
      color = `var(--bg-${breakpoint.color}-solid)`
      break
    }
  }

  options.value = {
    ...options.value,
    fill: {
      ...options.value.fill,
      colors: [color]
    }
  }

  return color
}

setFillColor()

// watch for changes in series prop
watch(
  () => props.modelValue,
  () => {
    // chartSeries.value = props.modelValue
    setFillColor()
  }
)
</script>

<style></style>
